const edadValidator = (value) => {
    return value >=18 && value <=100;
}

export { edadValidator }

